<template>
  <el-table-column
    prop="representative_id"
    label="#"
    width="70"
    fixed
  >
    <template slot-scope="scope">
      {{ scope.row.representative_id }}
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'id',
  };
</script>
